module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-step-2-variation"
  }, [_c('div', {
    staticClass: "order-step-2-variation__col-container",
    class: {
      'order-step-2__col-container--private': _vm.mode === 'private'
    }
  }, [(_vm.mode === 'business' || (_vm.mode === 'private' && _vm.privateDeliveryDay === 'monday')) ? _c('div', {
    staticClass: "order-step-2-variation__col order-step-2-variation__col-1"
  }, [_c('h3', {
    staticClass: "order-step-2-variation__col-heading"
  }, [_vm._v("Montag")]), _vm._v(" "), _c('div', {
    staticClass: "order-step-2-variation__amount-highlight"
  }, [_vm._v("\n                " + _vm._s(_vm.amounts.monday) + " kg\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "range-slider range-slider--on-light-bg"
  }, [_c('span', {
    staticClass: "range-slider__number range-slider__number--selected"
  }, [_vm._v("2 kg")]), _vm._v(" "), _c('input', {
    staticClass: "range-slider__input",
    attrs: {
      "name": "amount-monday",
      "type": "range",
      "min": "2",
      "max": "20"
    },
    domProps: {
      "value": _vm.amounts.monday
    },
    on: {
      "input": function($event) {
        return _vm.updateAmounts($event, 'monday')
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "range-slider__number range-slider__number--total"
  }, [_vm._v("21 kg")])])]) : _vm._e(), _vm._v(" "), (_vm.mode === 'private') ? _c('div', {
    staticClass: "order-step-2-variation__details-col-container order-step-2-variation__details-col-container--private"
  }, [_c('div', {
    staticClass: "order-step-2-variation__details-col order-step-2-variation__details-col-1"
  }, [_c('a', {
    staticClass: "order-step-2-variation__info-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleInfoModalVisible("Nach den Empfehlungen der Schweizerischen Gesellschaft für Ernährung sollte eine erwachsene Person täglich 5 Portionen Früchte und Gemüse in verschiedenen Farben zu sich nehmen. Unsere Liefermengen sind so berechnet, dass du täglich mit 1 bis 2 Portionen Früchte oder Gemüse versorgt wirst. Somit deckt der Öpfelchasper 20 bis 40 % deines Bedarfs an Rohkost.")
      }
    }
  }, [_vm._v("\n                    Mengenangaben\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "order-step-2-variation__details-col order-step-2-variation__details-col-2"
  }, [_c('div', {
    staticClass: "order-step-2-variation__info"
  }, [_vm._v("\n                    Total " + _vm._s(_vm.totalAmounts) + " kg/Woche (ca. " + _vm._s(_vm.peopleAmounts) + " Personen)\n                ")])])]) : _vm._e(), _vm._v(" "), (_vm.mode === 'business' || (_vm.mode === 'private' && _vm.privateDeliveryDay === 'wednesday')) ? _c('div', {
    staticClass: "order-step-2-variation__col order-step-2-variation__col-2"
  }, [_c('h3', {
    staticClass: "order-step-2-variation__col-heading"
  }, [_vm._v("Mittwoch")]), _vm._v(" "), _c('div', {
    staticClass: "order-step-2-variation__amount-highlight"
  }, [_vm._v("\n                " + _vm._s(_vm.amounts.wednesday) + " kg\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "range-slider"
  }, [_c('span', {
    staticClass: "range-slider__number range-slider__number--selected"
  }, [_vm._v("0 kg")]), _vm._v(" "), _c('input', {
    staticClass: "range-slider__input",
    attrs: {
      "name": "amount-wednesday",
      "type": "range",
      "min": "0",
      "max": "20"
    },
    domProps: {
      "value": _vm.amounts.wednesday
    },
    on: {
      "input": function($event) {
        return _vm.updateAmounts($event, 'wednesday')
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "range-slider__number range-slider__number--total"
  }, [_vm._v("21 kg")])])]) : _vm._e()]), _vm._v(" "), (_vm.mode === 'business') ? _c('div', {
    staticClass: "order-step-2-variation__details-col-container"
  }, [_c('div', {
    staticClass: "order-step-2-variation__details-col order-step-2-variation__details-col-1"
  }, [(_vm.mode === 'business') ? _c('a', {
    staticClass: "order-step-2-variation__info-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleInfoModalVisible("\n                        <div class='text-container'>\n                            <h3>Was bedeuten die Mengenangaben Chasperli, Öpfelchasper und Superchasper?</h3>\n                            <p>Unsere Mengenangaben stützen sich auf die Empfehlungen der Schweizerischen Gesellschaft für Ernährung. So sollte eine erwachsene Person täglich 5 Portionen Früchte und Gemüse in verschiedenen Farben zu sich nehmen, wobei 1 Portion rund 120 g entspricht. Pro Woche ist dies eine Gesamtmenge von 4.2 kg Gemüse und Früchte pro Person.\n                                <br/><br/>\n                                Das Abo «Bio fürs Büro» kann somit folgenden Bedarf an Früchten und/oder Gemüse decken:\n                                <br/><br/>\n                                Chasperli: 400 g pro Person und Woche (ca. 3 Portionen)<br/>\n                                Öpfelchasper: 600 g pro Person und Woche (ca. 5 Portionen)<br/>\n                                Superchasper: 800 g pro Person und Woche (ca. 7 Portionen)\n                            </p>\n                        </div>")
      }
    }
  }, [_vm._v("\n                Mengenangaben\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "order-step-2-variation__details-col order-step-2-variation__details-col-2"
  }, [_c('div', {
    staticClass: "order-step-2-variation__info"
  }, [_vm._v("\n                Total " + _vm._s(_vm.totalAmounts) + " kg/Woche (ca. " + _vm._s(_vm.peopleAmounts) + " Personen)\n            ")])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a38ee3b8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./static/js/Order/components/Amounts.vue
// module id = 743
// module chunks = 0